import { useNavigate, useParams } from 'react-router-dom';
import { ProjectAnalyticsView } from '@/components/projects/ProjectAnalyticsView';

export function ProjectDetailPage() {
  const { nip, projectId } = useParams<{ nip: string; projectId: string }>();
  const navigate = useNavigate();

  if (!nip || !projectId) return null;

  return (
    <ProjectAnalyticsView
      companyNip={nip}
      projectId={projectId}
      onBack={() => navigate(`/${nip}/projects`)}
      onInvoiceSelect={(invoiceId) => navigate(`/${nip}/invoices/${invoiceId}`)}
    />
  );
}
